import React, { useState } from "react";
import NavMenu from "./navMenu";

const StandardPage = ({ loggedIn, accountPermission, children }) => {
  const [show, setShow] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const handleOverlay = () => setShow(!show);
  const passImage = src => {
    setImgSrc(src);
  };
  return (
    <div>
      {show ? (
        <div
          className="tw-w-full tw-h-full tw-z-10 tw-fixed"
          style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
        >
          <div
            className="tw-flex tw-justify-end tw-p-3"
            onClick={handleOverlay}
          >
            <div
              className="hover:tw-text-red-500 tw-text-gray-300 tw-cursor-pointer tw-fixed"
              style={{ backgroundColor: "" }}
            >
              {/* <div className="hover:tw-text-red-500 tw-text-gray-300 tw-cursor-pointer tw-fixed" style={{ backgroundColor: '' }}> */}
              <svg
                className="tw-h-12 tw-w-12"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
          </div>
          <img
            className="enlargeImage"
            src={`data:image/png;base64, ${imgSrc}`}
            alt={`Enlarged Profile Pic`}
          />
        </div>
      ) : null}
      {loggedIn() && <NavMenu accountPermission={accountPermission} />}
      <div className="container">
        <div className="row">
          <div className="col-12">
            {React.cloneElement(children, { handleOverlay, passImage })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StandardPage;
